import {
  ServerProductKeys,
  ServerProductKey,
  CloudProductKeys,
  ExtraProductKeys,
} from 'data/products/keys';
import config from '../../appconfig';

export const ServerProductPricingLinks: { [product in ServerProductKey]?: string } = {
  [ServerProductKeys.BITBUCKET]: 'https://www.atlassian.com/software/bitbucket/pricing',
  [ServerProductKeys.CONFLUENCE]: 'https://www.atlassian.com/software/confluence/pricing',
  [ServerProductKeys.JIRA_SOFTWARE]: 'https://www.atlassian.com/software/jira/pricing',
  [ServerProductKeys.JIRA_SERVICE_DESK]:
    'https://www.atlassian.com/software/jira/service-management/pricing',
  [ServerProductKeys.JIRA_CORE]: 'https://www.atlassian.com/software/jira/work-management/pricing',
};

export const CloudProductEvaluationLinks: { [key: string]: string } = {
  [CloudProductKeys.CONFLUENCE]: 'https://www.atlassian.com/software/confluence/try',
  [CloudProductKeys.BITBUCKET]: 'https://bitbucket.org/account/signup/',
  [CloudProductKeys.CONFLUENCE_TEAM_CALENDARS]:
    'https://marketplace.atlassian.com/apps/72307/team-calendars-for-confluence',
  [CloudProductKeys.JIRA_CORE]: 'https://www.atlassian.com/software/jira/core/try',
  [CloudProductKeys.JIRA_PORTFOLIO]:
    'https://marketplace.atlassian.com/apps/1212136/portfolio-for-jira',
  [CloudProductKeys.JIRA_SERVICE_DESK]: 'https://www.atlassian.com/software/jira/service-desk/try',
  [CloudProductKeys.JIRA_SOFTWARE]: 'https://www.atlassian.com/software/jira/try',
  [CloudProductKeys.CONFLUENCE_QUESTIONS]:
    'https://marketplace.atlassian.com/apps/1211644/questions-for-confluence',
  [ExtraProductKeys.ATLASSIAN_CLOUD]: `${config.wacUrl}/ondemand/signup/#/`,
};
